import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { validateResetToken, resetPassword } from '../api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [tokenValid, setTokenValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setError('Kein Token angegeben.');
      setLoading(false);
      return;
    }
    
    const checkToken = async () => {
      try {
        const data = await validateResetToken(token);
        if (data.success) {
          setTokenValid(true);
          setUser(data.user);
        } else {
          setError(data.error || 'Ungültiger oder abgelaufener Link.');
        }
      } catch (err) {
        setError('Fehler bei der Serveranfrage.');
      } finally {
        setLoading(false);
      }
    };
    
    checkToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!newPassword || newPassword.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    
    setSubmitting(true);
    
    try {
      const data = await resetPassword(token, newPassword);
      if (data.success) {
        setSuccess('Passwort erfolgreich gesetzt! Du kannst dich jetzt einloggen.');
        setTimeout(() => navigate('/'), 2500);
      } else {
        setError(data.error || 'Fehler beim Zurücksetzen des Passworts.');
      }
    } catch (err) {
      setError('Fehler bei der Serveranfrage.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '60px auto', background: 'white', borderRadius: 8, boxShadow: '0 2px 12px #0001', padding: 32 }}>
      <h2 style={{ color: '#4a6de5', marginBottom: 24 }}>Passwort zurücksetzen</h2>
      {loading ? (
        <div>Lade...</div>
      ) : error ? (
        <div style={{ color: 'red', marginBottom: 16 }}>{error}</div>
      ) : success ? (
        <div style={{ color: 'green', marginBottom: 16 }}>{success}</div>
      ) : tokenValid && user ? (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label>Neues Passwort</label>
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', marginTop: 4 }}
              minLength={6}
              required
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label>Passwort bestätigen</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', marginTop: 4 }}
              minLength={6}
              required
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            style={{ width: '100%', background: '#4a6de5', color: 'white', padding: 12, border: 'none', borderRadius: 4, fontWeight: 600, fontSize: 16, cursor: 'pointer' }}
          >
            {submitting ? 'Setze Passwort...' : 'Passwort setzen'}
          </button>
        </form>
      ) : null}
    </div>
  );
}

export default ResetPassword; 